module.exports = __webpack_public_path__ + "img/hr-burner-mining-drill-W-shadow.575bdf7a.png";